import ContactInfo from 'src/models/contactInfo.js';
import Address from 'src/models/address.js';
import Role from 'src/models/role.js';
import Gender from 'src/models/gender.js';
import Policy from 'src/models/policy.js';
import FinancialSummary from 'src/models/financialSummary.js';
import MedicalSelection from 'src/models/medicalSelection.js';
import { isDateStringOlderThanNYears } from 'src/utils/helpers.js';
import i18n from 'src/i18n/index.js';
import { store } from 'src/store/index.js';
import { formatDateWithoutTime } from 'src/utils/format';

class Customer {
  constructor(params) {
    if (!params) return undefined;

    this.initials = params.initials;
    this.prefix = `${params.prefix ? params.prefix : ''} `;
    this.firstName = params.firstName;
    this.lastName = params.lastName;
    this.prefixBirthName = `${params.prefixBirthName ? params.prefixBirthName : ''} `;
    this.birthName = `${params.birthName ? params.birthName : ''}`;

    this.fullLastName = `${this.prefix}${this.lastName}`;
    this.fullBirthName = `${this.prefixBirthName ? this.prefixBirthName : ''}${this.birthName}`;

    this.fullName = `${this.initials} ${this.fullLastName} ${params.birthName ? '-' : ''} ${this.fullBirthName}`;

    this.fullNameWithSalutation = `${i18n.global.t(`gender.salutation-${params.gender.toLowerCase()}`)} ${this.fullName}`;
    this.fullNameWithShortHandSalutation =
      `${i18n.global.t(`gender.short-hand-salutation-${params.gender.toLowerCase()}`)} ${this.fullName}`.trim();

    this.birthDate = params.birthDate;

    this.isAdult = isDateStringOlderThanNYears(params.birthDate, 18);
    this.is16AndOlder = isDateStringOlderThanNYears(params.birthDate, 16);
    this.customerNumber = parseInt(params.customerNumber);
    this.gender = new Gender(params.gender);
    this.role = new Role(params.role);

    this.isCustomerUser = store.getters['user/user'].customerNumber === this.customerNumber;
    this.address = undefined;
    this.policies = [];
    this.contactInfo = undefined;
    this.financialSummary = undefined;

    if (params.policies) {
      const dates = params.policies.map((x) => new Date(x.startDate));
      this.startDate = formatDateWithoutTime(new Date(Math.max.apply(null, dates)), 'yyyy-MM-dd');
    }

    this.medicalSelection = params.medicalSelection ? new MedicalSelection(params.medicalSelection) : undefined;
    return this;
  }

  addAddress(address) {
    this.address = new Address(address);
    return this;
  }

  addContactInfo(contactInfo) {
    this.contactInfo = new ContactInfo(contactInfo);
    return this;
  }

  addPolicies(policies) {
    this.policies = policies.map((policy) => new Policy(policy));
    return this;
  }

  addPolicy(policy) {
    this.policies.push(new Policy(policy));
    return this;
  }

  addFinancialSummary(financialSummary) {
    this.financialSummary = new FinancialSummary(financialSummary);

    return this;
  }
}
export { Customer as default };
